// extracted by mini-css-extract-plugin
export default {"current":"account-switcher_current__UkhT1","check":"account-switcher_check__+jHBR","current-typo":"account-switcher_current-typo__KTfSQ"};